import { tracking } from '@services/analytics';
import electronService from '@services/electron/electron.service';
import { logger } from '@services/logger/logger.service';
import { trayMenu } from '.';

export async function registerAutoUpdaterListeners() {
  const osPlatform = await electronService.getPlatform();
  const autoUpdater = window.electron.getAutoUpdater();

  autoUpdater.on('checking-for-update', () =>
    logger.info('DESKTOP', `AutoUpdater: <checking-for-update>`),
  );

  autoUpdater.on('error', (error: Error) => {
    logger.error('DESKTOP', `AutoUpdater: <error> ${error}`, {}, false);
    tracking.appUpdateFailed({ errorCause: error?.message });
  });

  autoUpdater.on('update-available', () => {
    logger.info('DESKTOP', `AutoUpdater: <update-available>`);
    tracking.appUpdateStarted({});
  });

  autoUpdater.on('update-not-available', () => {
    logger.info('DESKTOP', `AutoUpdater: <update-not-available>`);
  });

  autoUpdater.on('update-downloaded', (_event: Event, releaseName: string, url: string) => {
    logger.info('DESKTOP', `AutoUpdater: <update-downloaded> ${releaseName} ${url}`);
    tracking.appUpdateCompleted({});
    trayMenu.addUpdater();
  });

  autoUpdater.on('before-quit-for-update', () => {
    logger.info('DESKTOP', `AutoUpdater: <before-quit-for-update>`);
    if (osPlatform === 'darwin') {
      window.electron.quitApp();
    }
  });
}
